import { IGetComboModifiersShort } from 'types';
import { serviceGetComboModifiersShort } from 'services/api/comboModifiers';
import { createAppErrorMessage } from 'utils/helpers';

const getComboModifiersShortInfo = async (args: IGetComboModifiersShort) => {
	try {
		const response = await serviceGetComboModifiersShort(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

export { getComboModifiersShortInfo };
